import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../../util';
import EditUserAccessModal from './EditUserAccessModal';
import claimGroupService from '../../services/claim_group.service';
import userAccessService from '../../services/user_access.service';
import UserAccessProjectBadges from './UserAccessProjectBadges';
import UserAccessBusinessUnitBadges from './UserAccessBusinessUnitBadges';
import { PROJECT_OVERVIEW_ALL_CONTACTS_MAX_AMOUNT_OF_PROJECT_BADGES } from '@rd-web-markets/market/dist/constants';
const AllContactsTab = _ref => {
  let {
    claimGroup,
    setClaimGroup,
    company,
    claimGroupStepAccess,
    setEngagementTeam
  } = _ref;
  const {
    t
  } = useTranslation();
  const [userAccessToEdit, setUserAccessToEdit] = useState(null);
  const [editModalShow, setEditModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const onSubmit = async userAccess => {
    const updatedUserAccess = await userAccessService.update(claimGroup.id, userAccess);
    const updatedClaimGroup = await claimGroupService.get(claimGroup.id);
    setClaimGroup(updatedClaimGroup);
    if (updatedUserAccess.included_in_engagement_team) {
      setEngagementTeam(prev => {
        if (!prev) return {
          clients: [],
          accountants: []
        };
        const isAccountant = updatedUserAccess.roles.includes('accountant');
        const arrayKey = isAccountant ? 'accountants' : 'clients';
        const updatedArray = [...(prev[arrayKey] || [])];
        const newEntry = {
          ...updatedUserAccess.user,
          user_access: {
            ...updatedUserAccess
          }
        };
        const index = updatedArray.findIndex(e => e.user_access.id === updatedUserAccess.id);
        if (index >= 0) {
          updatedArray[index] = newEntry;
        } else {
          updatedArray.push(newEntry);
        }
        return {
          ...prev,
          [arrayKey]: updatedArray
        };
      });
    }
  };
  const headers = [{
    text: t('name'),
    filterableByText: true,
    sortable: true,
    valueFnForSortAndFilter: r => r.data.object.user.name || '',
    width: '350px'
  }, {
    text: t('role'),
    filterableByText: true,
    sortable: true,
    valueFnForSortAndFilter: r => r.data.object.user.role || '',
    width: '300px'
  }, {
    text: t('business_unit'),
    filterableByText: true,
    valueFnForSortAndFilter: r => r.data.object.user_access_business_unit_participations.map(p => p.business_unit.name).join(' ') || '',
    width: '350px'
  }, {
    text: t('projects'),
    filterableByText: true,
    sortable: false,
    valueFnForSortAndFilter: r => r.data.object.user_access_project_participations.map(p => p.claim_project_report.project_name).join(' ') || '',
    width: '370px'
  }, {
    text: t('email'),
    filterableByText: true,
    sortable: true,
    valueFnForSortAndFilter: r => r.data.object.user.email || '',
    width: '300px'
  }, {
    text: t('phone'),
    filterableByText: true,
    sortable: true,
    valueFnForSortAndFilter: r => r.data.object.user.phone_number || '',
    width: '300px'
  }];
  const onEdit = useCallback((rowIndex, row) => {
    const userAccess = row.data.object;
    setUserAccessToEdit(userAccess);
    setEditModalShow(true);
  }, []);
  const deleteUserClaimGroupAccess = userAccessService.useDeleteUserAccess(claimGroup, setClaimGroup, setLoading);
  const onDelete = useCallback((rowIndex, row) => {
    const userAccess = row.data.object;
    deleteUserClaimGroupAccess(userAccess.id);
  }, [deleteUserClaimGroupAccess]);
  console.log('All contacts tab - claim group user accesses:', claimGroup.user_accesses);
  const rows = claimGroup.user_accesses?.filter(userAccess => userAccess.included_in_engagement_team !== true).map(userAccess => {
    return {
      key: userAccess.id,
      data: {
        object: userAccess
      },
      columns: [userAccess.user?.name, userAccess.roles.map(role => t(role)).join(', '), /*#__PURE__*/React.createElement(UserAccessBusinessUnitBadges, {
        userAccess: userAccess
      }), /*#__PURE__*/React.createElement(UserAccessProjectBadges, {
        userAccess: userAccess,
        maxAmountOfBadges: PROJECT_OVERVIEW_ALL_CONTACTS_MAX_AMOUNT_OF_PROJECT_BADGES
      }), userAccess.user?.email, userAccess.user?.phone_number]
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, userAccessToEdit && /*#__PURE__*/React.createElement(EditUserAccessModal, {
    company: company,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    title: t('edit_contact'),
    onHide: () => setEditModalShow(false),
    show: editModalShow,
    userAccess: userAccessToEdit,
    onSubmit: onSubmit
  }), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    onEdit: claimGroupStepAccess.canEditAnyTypeOfUser ? onEdit : null,
    onDelete: claimGroupStepAccess.canEditAnyTypeOfUser ? onDelete : null
  }));
};
export default AllContactsTab;